<script setup lang="ts">
import { ChevronDown, ChevronRight, GripVertical } from 'lucide-vue-next';

defineProps<{
  title: string;
  count: number;
  collapsed: boolean;
  color?: string;
  draggable?: boolean;
  dropTarget?: boolean;
}>();

const emit = defineEmits<{
  (event: 'toggle'): void;
  (event: 'drag-start'): void;
  (event: 'drag-end'): void;
  (event: 'drag-over'): void;
  (event: 'drag-leave'): void;
  (event: 'drop'): void;
}>();
</script>

<template>
  <div
    class="flex items-center gap-1.5 rounded-xl px-1.5 py-1 transition-all"
    :class="dropTarget ? 'bg-primary/8 ring-1 ring-primary/25 ring-inset' : ''"
    @dragover.prevent="emit('drag-over')"
    @dragleave="emit('drag-leave')"
    @drop.prevent="emit('drop')"
  >
    <button
      v-if="draggable"
      type="button"
      draggable="true"
      class="inline-flex size-7 cursor-grab items-center justify-center rounded-md text-muted-foreground/70 transition-colors hover:bg-muted/25 hover:text-muted-foreground active:cursor-grabbing"
      :aria-label="`Reorder ${title}`"
      @dragstart.stop="emit('drag-start')"
      @dragend="emit('drag-end')"
    >
      <GripVertical class="size-3.5" />
    </button>

    <button
      type="button"
      class="flex min-w-0 flex-1 flex-wrap items-center gap-1.5 rounded-xl py-1 text-left transition-colors hover:bg-muted/35"
      :aria-expanded="!collapsed"
      @click="emit('toggle')"
    >
      <ChevronRight v-if="collapsed" class="size-4 text-muted-foreground" />
      <ChevronDown v-else class="size-4 text-muted-foreground" />
      <span
        class="size-2.5 rounded-full"
        :style="{ backgroundColor: color || 'var(--primary)' }"
        aria-hidden="true"
      />
      <h3 class="text-base font-semibold tracking-tight text-foreground">{{ title }}</h3>
      <span class="text-sm text-muted-foreground">{{ count }}</span>
    </button>
  </div>
</template>
